module.exports = __webpack_public_path__ + "media/images/icons/outlined/minus-d279c2e775d6977f4431cb0b625bf666.svg";